<script setup>
import { ref } from 'vue';
import { Head, useForm } from '@inertiajs/vue3';
import HsAuthenticationCard from '@/Components/AuthenticationCard.vue';
import HsAuthenticationCardLogo from '@/Components/AuthenticationCardLogo.vue';
import HsButton from '@/Components/Button.vue';
import HsInput from '@/Components/Input.vue';
import JetLabel from '@/Jetstream/Label.vue';
import HsValidationErrors from '@/Components/ValidationErrors.vue';

const form = useForm({
    password: '',
});

const passwordInput = ref(null);

const submit = () => {
    form.post(route('password.confirm'), {
        onFinish: () => {
            form.reset();

            passwordInput.value.focus();
        },
    });
};
</script>
<style scoped>
@import "../../../../public/ui/vendor/css/pages/page-auth.css";
</style>
<template>

    <Head title="Secure Area" />

    <HsAuthenticationCard>
        <template #logo>
            <HsAuthenticationCardLogo />
        </template>

        <div class="mb-4 text-sm text-gray-600">
            This is a secure area of the application. Please confirm your password before continuing.
        </div>

        <HsValidationErrors class="mb-4" />

        <form @submit.prevent="submit">
            <div>
                <label for="password" class="form-label">Password</label>
                <HsInput id="password" ref="passwordInput" v-model="form.password" type="password"
                    class="mt-1 block w-full" required autocomplete="current-password" autofocus />
            </div>

            <div class="flex justify-end mt-4">
                <HsButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    Confirm
                </HsButton>
            </div>
        </form>
    </HsAuthenticationCard>
</template>
